import type { Order } from '../../types';
import { translateError } from '../../utils/helpers';
import { supabase } from '../supabaseClient';

export async function fetchOrdersForUser(userId: string): Promise<Order[]> {
  const { data, error } = await supabase.from('orders').select('*').eq('user_id', userId).order('date', { ascending: false });
  if (error) throw new Error(translateError(error));
  return data ?? [];
}

export async function fetchAllOrdersAdmin(): Promise<Order[]> {
  const { data, error } = await supabase
    .from('orders')
    .select('*, user:profiles(nom, prénom, email, téléphone, adresse)')
    .order('date', { ascending: false });
  if (error) throw new Error(translateError(error));
  return (data as unknown as Order[]) ?? [];
}
